import React from 'react'
import Lottie from 'react-lottie';
import animation_confirmation from './animation-lottie/Check-for-bundel.json'
import ThemedLottie from '../../../../Shared/ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../../../utilities/theme/ThemeColorEnum';

const AssemblePackage = (props) => {



    return (
        <div className='assemble-package'>
            {/* <Lottie options={defaultOptions} height={250} width={250} /> */}
            <ThemedLottie animationData={animation_confirmation}
                color={ThemeColorEnum.PRIMARY} 
                height={250}
                width={250} 
                loop={true} 
                autoplay={true}
                rendererSettings={{
                    preserveAspectRatio: 'xMidYMid slice',
                }}
             />

            <p>
                ממשיכים בהרכבת
                <br />
                החבילה שלך!
            </p>

        </div>
    );
};


export default AssemblePackage;
